import { FC } from 'react'

type Props = {
  details: any
}

const CertificateViewModalForm: FC<Props> = ({details}) => {
  

    return (
        <div className="card flex-grow-1 min-w-300px" >
        
        <h3 className="my-2">Certificate of Conformity No. {details.cocNumber}</h3>
        
        <div className="card-body d-flex flex-column align-items-stretch gap-2 px-0">
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Certificate Holder</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.certificateHolder}</span>
                </div>
            </div>            
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Certificate Number</label>
                <div className='col-sm-8 col-md-3 col-lg-4'>
                    <span className='fw-bolder fs-7 text-dark me-4'>{details.cocNumber}</span>
                    
                </div>                    
                <label className='col-sm-4 col-md-3 col-lg-3 fw-bold text-muted fs-7'>Previous CoC Number</label>
                <div className='col-sm-8 col-md-3 col-lg-3'>
                    <span className='fw-bolder fs-7 text-dark'>{details.previousCocNumber}</span>
                </div>                    
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Scheme Type</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.scheme}</span>
                </div>
            </div>            
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Product Category</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.productCategoryString}</span>
                </div>
            </div>            
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Product</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.product}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Brand</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.brand}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Model</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.model}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Country of Origin</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.country}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Product Details</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.productDetails}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Standards</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.standards}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Test Reports</label>
                <div className='col-sm-8 col-md-9 col-lg-10'>
                    <span className='fw-bolder fs-7 text-dark'>{details.testReports}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Issue Date</label>
                <div className='col-sm-8 col-md-3 col-lg-4'>
                    <span className='fw-bolder fs-7 text-dark'>{details.issueDate}</span>
                </div>
                <label className='col-sm-4 col-md-3 col-lg-3 fw-bold text-muted fs-7'>Expiration Date</label>
                <div className='col-sm-8 col-md-3 col-lg-3'>
                    <span className='fw-bolder fs-7 text-dark'>{details.expirationDate}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Status</label>
                <div className='col-sm-8 col-md-3 col-lg-4'>
                    <span className='fw-bolder fs-7 text-dark'>{details.status}</span>
                </div>
                <label className='col-sm-4 col-md-3 col-lg-3 fw-bold text-muted fs-7'>Effective Date of Status</label>
                <div className='col-sm-8 col-md-3 col-lg-3'>
                    <span className='fw-bolder fs-7 text-dark'>{details.effectiveDate}</span>
                </div>
            </div>
            <div className='row'>
                <label className='col-sm-4 col-md-3 col-lg-2 fw-bold text-muted fs-7'>Date of Last Revision</label>
                <div className='col-sm-8 col-md-3 col-lg-4'>
                    <span className='fw-bolder fs-7 text-dark'>{details?.lastRevisionDate ? details?.lastRevisionDate : ''}</span>
                </div>
                
            </div>            
        </div>
    </div>
        
    )
}

export {CertificateViewModalForm}
